import React, { Component } from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { updateFeedProviders } from '../actions/apiFeedCenter';

class EditFeedProvider extends Component {
	constructor(props) {
		super(props);

		this.state = {
			value: this.props.value || '',
		};
		this.onChangeInput = this.onChangeInput.bind(this);
		this.onBlur = this.onBlur.bind(this);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.value !== this.props.value && this.props.value !== this.state.value) {
			this.setState({ value: this.props.value || '' });
		}
	}

	onChangeInput(e) {
		this.setState({ value: e.target.value });
		if (this.props.onChange) {
			this.props.onChange(e.target.name, e.target.value);
		}
	}

	onBlur(e) {
		if (this.props.deferSave) {
			return;
		}

		if (e.target.value !== this.props.value) {
			const errorType = 'updateFeedProviders';
			const data = {
				id: this.props.parentid,
				[e.target.name]: e.target.value,
			};

			this.setState({ value: e.target.value });
			this.props.updateFeedProviders(this.props.parentid, data, errorType).catch(() => {});
		}
	}

	render() {
		return (
			<div className="col-md-12">
				<div className="card departmentCard">
					<div className="card-body row">
						<div className="col-md-12">
							<div className={classnames('form-group', { 'has-danger': this.props.error })}>
								<div className="form-group">
									<label className="control-label">{this.props.label}</label>
									<input
										onChange={this.onChangeInput}
										onBlur={this.onBlur}
										value={this.state.value}
										type="text"
										name={this.props.name}
										data-id={this.props.parentid}
										placeholder={this.props.placeholder}
										className={classnames('form-control ', { 'form-control-danger': this.props.error })}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const mappedActions = {
	updateFeedProviders,
};

export default connect(null, mappedActions)(EditFeedProvider);
